import { useEffect } from 'react';

export default function PageWrapper({ children }) {
  useEffect(() => {
    document.documentElement.classList.add('fixed-layout');
    document.body.classList.add('fixed-layout');

    return () => {
      document.documentElement.classList.remove('fixed-layout');
      document.body.classList.remove('fixed-layout');
    };
  }, []);

  return (
    <div
      className="App page"
      style={{
        height: '100%', // fill whatever html/body provide
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </div>
  );
}
